import { useAgentProfile } from './useAgentProfile';
import { AgentProfile } from 'ui/components/common/patterns/AgentProfile/AgentProfile';

/**
 * 買い手企業が見る仲介企業のプロフィール
 */
export const BuyerAgentProfile: React.FC = () => {
    const { agent } = useAgentProfile();
    if (!agent) return null;

    return <AgentProfile agent={agent} />;
};
